import styled from 'styled-components';

const Primary = styled.span`
  color: ${p => p.theme.colors.primary};
`;

export default Primary;
